<script lang="ts">
  import Tag from '$shared/atoms/Tag/Tag.svelte';
  import { TagSize } from '$shared/constants/TagSize';
  import Title from '$shared/atoms/Title/Title.svelte';
  import Menu from '$shared/molecules/Menu/Menu.svelte';
  import type { CustomComponent } from '$shared/components/types';
  import { type Snippet } from 'svelte';
  import ActionsComp from './Actions.svelte';

  interface Props {
    title: string;
    readonly?: boolean;
    name?: string;
    statusTag?: string;
    loading?: boolean;
    hideActions?: boolean;
    hasCustomAction?: boolean;
    actions?: any;
    moreOption?: { list: CommonList[]; loading?: boolean };
    customHeader?: CustomComponent;
    customAction?: Snippet | undefined;
    children?: Snippet | undefined;
    onoption?: (option: any) => void;
    onedit?: () => void;
    onremove?: () => void;
    onreverify?: () => void;
    onevent?: (payload: any) => void;
  }

  let {
    title,
    readonly = false,
    name = '',
    statusTag = '',
    loading = false,
    hideActions = false,
    hasCustomAction = false,
    actions = [],
    moreOption = null,
    customHeader = null,
    customAction = undefined,
    children = undefined,
    onoption,
    onedit,
    onremove,
    onreverify,
    onevent
  }: Props = $props();

  const onClickOptions = (option) => {
    onoption?.(option);
  };
</script>

<div class="entity-view-header">
  <div class="entity-header">
    <div data-cy={`${name}-header`} class="title-container">
      <div class="title" class:has-tag={!!statusTag}>
        <Title type="h2">{title || ''}</Title>
        {#if statusTag}
          <div data-cy={`${name}-status`} class="tag">
            <Tag name={statusTag} size={TagSize.Small}>{statusTag}</Tag>
          </div>
        {/if}
      </div>

      {#if customHeader?.component}
        {@const SvelteComponent = customHeader?.component}
        <SvelteComponent {...customHeader?.props || {}} {onevent} />
      {/if}
    </div>

    {#if hasCustomAction}
      {@render customAction?.()}
    {:else}
      <div class="actions-wrap">
        {#if !hideActions}
          {#if !loading}
            {@render children?.()}
          {/if}
          <ActionsComp {readonly} {loading} list={actions} {onedit} {onremove} {onreverify} />
          {#if !loading && moreOption?.list && moreOption?.list?.length !== 0}
            <div class="options">
              <Menu {...moreOption} onclick={onClickOptions} />
            </div>
          {/if}
        {/if}
      </div>
    {/if}
  </div>
</div>

<style>
  .entity-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .title.has-tag {
    display: flex;
    align-items: center;
  }
  .title.has-tag .tag {
    margin-left: 8px;
  }
  .actions-wrap {
    display: flex;
    align-items: center;
  }
  .options {
    margin-left: 8px;
  }
</style>
